module.exports = __webpack_public_path__ + "static/media/sound1.79eaf836.mp3";